import { createReducer } from 'typesafe-actions';
import { get } from '../../../common/utils/objectUtils';
import { ValuePropsActionTypes, ValuePropsActions } from './actions';
import { ValuePropsState, RemoteValueProp, ValueProp } from './types';

const defaultState: ValuePropsState = {
    didInvalidate: false,
    identifier: '',
    isFetching: false,
};

/**
 * Parse the ValueProp from the api to a minimun viable redux object
 * @param remoteValueProp the contentful entity
 */
export const remoteValuePropToLocal = (remoteValueProp: RemoteValueProp): ValueProp => ({
    title: get(remoteValueProp, 'name', ''),
    imageSrc: `https:${get(remoteValueProp, 'image.file.url', '')}`,
    link: get(remoteValueProp, 'link'),
});

const valuePropsReducer = createReducer<ValuePropsState, ValuePropsActionTypes>(defaultState)
    .handleAction(ValuePropsActions.success, (state, { payload }) => {
        const remoteValueProps = get(payload, 'data.data', []);
        const valueProps = remoteValueProps.map(remoteValuePropToLocal);

        return {
            ...state,
            didInvalidate: valueProps.length !== 3,
            isFetching: false,
            valueProps,
        };
    })
    .handleAction(ValuePropsActions.failure, (state, { payload }) => {
        return {
            ...state,
            isFetching: false,
            didInvalidate: true,
            error: payload.error,
        };
    })
    .handleAction(ValuePropsActions.request, state => {
        return {
            ...state,
            isFetching: true,
            didInvalidate: false,
        };
    });

export default valuePropsReducer;
